import {block} from '../utils/cn';

export const bTabList = block('tab-list');
export const bTab = block('tab');
export const bTabPanel = block('tab-panel');

export const TAB_DATA_ATTRIBUTE = 'data-tab';
